import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Matches the primary blue already used throughout the merchant dashboard (#1890ff).
export const BRAND_BLUE = '#1890ff';

// No styled-components ThemeProvider wraps this component in the tree, so
// dark mode is read directly from ThemeContext and passed down as a
// transient prop instead of relying on styled-components' theme context.
export const NavBar = styled.nav<{ $isDark: boolean }>`
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${({ $isDark }) => ($isDark ? 'rgba(26, 32, 44, 0.85)' : 'rgba(255, 255, 255, 0.85)')};
  backdrop-filter: saturate(180%) blur(14px);
  border-top: 1px solid ${({ $isDark }) => ($isDark ? 'rgba(255, 255, 255, 0.08)' : '#e2e8f0')};
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  box-shadow: ${({ $isDark }) =>
    $isDark ? '0 -8px 24px rgba(0, 0, 0, 0.45)' : '0 -8px 24px rgba(0, 0, 0, 0.08)'};
  justify-content: space-around;
  align-items: center;
  height: 4.75rem;
  padding-bottom: env(safe-area-inset-bottom, 0px);

  /* Matches Chakra's old base/md breakpoint split — visible below 768px only. */
  @media (max-width: 767px) {
    display: flex;
  }
`;

export const NavTab = styled(Link)<{ $active: boolean; $isDark: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  flex: 1;
  height: 100%;
  color: ${({ $active, $isDark }) => ($active ? BRAND_BLUE : $isDark ? '#718096' : '#a0aec0')};
  text-decoration: none;
  transition: color 0.2s ease;
`;

export const NavIconPill = styled.span<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: ${({ $active }) => ($active ? BRAND_BLUE : 'transparent')};
  color: ${({ $active }) => ($active ? '#fff' : 'inherit')};
  box-shadow: ${({ $active }) => ($active ? '0 4px 12px rgba(24, 144, 255, 0.35)' : 'none')};
  transform: ${({ $active }) => ($active ? 'translateY(-2px) scale(1.06)' : 'translateY(0) scale(1)')};
  transition: background 0.25s ease, box-shadow 0.25s ease,
    transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  font-size: ${({ $active }) => ($active ? '18px' : '16px')};
`;

export const NavLabel = styled.span<{ $active: boolean }>`
  font-size: 10.5px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  line-height: 1;
  letter-spacing: 0.2px;
  transform: ${({ $active }) => ($active ? 'translateY(-2px)' : 'translateY(0)')};
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
`;
